import type { FunctionComponent } from "react";

import { tracking } from "shared/data";

import { Button } from "scmp-app/components/posties/button";

import { Container, Description, StyledImage, Title } from "./styles";

type Props = NewsFromScmpEducation & {
  className?: string;
};

export const PostiesNewsFromScmpEducationItem: FunctionComponent<Props> = ({
  buttonText,
  className,
  desc,
  imageUrl,
  link,
  title,
}) => {
  const postiesBrochureHomepageScmpEducationQueryParameters = {
    module: tracking.module.SCMPEducation,
    pgtype: tracking.pageType.Brochure,
  };

  return (
    <Container className={className}>
      <StyledImage
        $aspectRatio="420 / 272"
        $height="auto"
        $objectFit="cover"
        $width="420px"
        alt={title}
        src={imageUrl}
      />
      <Title>{title}</Title>
      <Description>{desc}</Description>
      <Button
        pathname={link}
        query={postiesBrochureHomepageScmpEducationQueryParameters}
        variant="link"
      >
        {buttonText}
      </Button>
    </Container>
  );
};

PostiesNewsFromScmpEducationItem.displayName = "PostiesNewsFromScmpEducationItem";
